export const config = {
    // backend_url : "http://localhost:4000/api/v1"
    backend_url : "https://todobackend-ncfx.onrender.com/api/v1"

}